import { createContext, useContext, useState } from "react";

export const TeamContext = createContext(null);

export const TeamContextProvider = ({ children }: any) => {
  const [currentSelectedTeam, setCurrentSelectedTeam] = useState(null);
  const [latestCondensedGame, setLatestCondensedGame] = useState(null);
  return (
    <TeamContext.Provider
      value={
        {
          currentSelectedTeam,
          setCurrentSelectedTeam,
          latestCondensedGame,
          setLatestCondensedGame,
        } as any
      }
    >
      {children}
    </TeamContext.Provider>
  );
};

export const useTeamContext = () => {
  const context = useContext(TeamContext);
  if (!context) {
    throw new Error("useTeamContext must be used within a TeamContextProvider");
  }
  return context;
};
